export default __webpack_public_path__ + "static/logo_sowos_by_columbus_white-b20b7f3047c73043a2a4c82464522bad.svg";